import http from '../utils/http'
//
/**
 * //https://yjz.hsnms.com/app/mutual/assistance/3?appid=202108&type_id=3001
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

let resquest = "http://jjbwg.hsnms.com:18080/admin";//椒江博物馆
let appid = 202011;

// let resquest = "http://36.133.85.117:16060/admin";//义家帮助
// let appid = 202108;
let token_id="admintoken";
let users_id="adminuser";

export function getAPI(url, params) {
	console.log(`${resquest}/${url}&callback=json&appid=${appid}`);
	return http.get(`${resquest}/${url}&callback=json&appid=${appid}`, params)
}
export function postAPI(url, params) {
	console.log(`${resquest}/${url}&callback=json&appid=${appid}`);
	return http.post(`${resquest}/${url}&callback=json&appid=${appid}`, params)
}

//设置Token
export function setToken(Token) {
	window.sessionStorage.setItem(token_id, JSON.stringify(Token));
}
//设置获取 Token
export function getToken() {
	const info = JSON.parse(window.sessionStorage.getItem(token_id))
	if (info == null) {
		alert("用户失效，请从新登陆");
		window.location.href = ".#/admin/login";
		
	}
	console.log(info);
	return info
}
export function getUser() {
	const info = JSON.parse(window.sessionStorage.getItem(users_id))
	return info
}
export function setUser(username) {
	window.sessionStorage.setItem(users_id, JSON.stringify(username));
}
export function delUser() {
	window.sessionStorage.removeItem(users_id);
	window.sessionStorage.removeItem(token_id);
	window.location.href = ".#/admin/login";
}


//返回 Appid
export function getAppid() {
	return appid
}


//获取用户model
export function getUserInfo() {
	const info = JSON.parse(window.sessionStorage.getItem('user_model'))
	console.log(info);
	return info
}
//更新用户model
export function getUserInfo_updata(openid) {
	http.get(`${resquest}/mutual/attribute/?appid=202108&type_id=4001`, {
		openid: openid
	}).then(res => {
		const user_model = res.data.data.data[0].models[0];
		console.log(user_model);
		console.log("user_model");
		const rowObj = JSON.stringify(user_model)
		window.sessionStorage.setItem('user_model', rowObj);
	});
}







// get请求
export function getListAPI(params) {
	console.log(params);
	return http.get(`${resquest}/mutual/assistance/3?appid=202108&type_id=3001`, params)
}
// post请求
export function postFormAPI(params) {
	return http.post(`${resquest}/postForm.json`, params)
}
// put 请求
export function putSomeAPI(params) {
	return http.put(`${resquest}/putSome.json`, params)
}
// delete 请求
export function deleteListAPI(params) {
	return http.delete(`${resquest}/deleteList.json`, params)
}



// WEBPACK FOOTER //
// ./src/api/admin.js